import React, { useState } from 'react'
import { PermissoesInterface } from '../ImportBackend/Interfaces/SistemaModuloPermissaoInterfaces'
import { TipoUsuario } from '../ImportBackend/Interfaces/RolesInterfaces'

export interface LoginStateInterface {
  token: string
  nome: string
  logado: boolean
  tipo: TipoUsuario
  idUsuario: number
  permissoes: Array<PermissoesInterface>
}

export default function useLoginState () {

  const [loginState, setLoginState] =
    useState<LoginStateInterface>( {
      token: '',
      nome: '',
      idUsuario: 0,
      logado: false,
      tipo: TipoUsuario.NAO_LOGADO,
      permissoes: []
    } )

  return { loginState, setLoginState }

}